
export default async function fetchData(url:string, token:string, params:any):
Promise<{status:boolean,reason:string, result:any}>{
    let status: boolean                 = false;
    let reason: string                  = "";
    let result: any                     = {};

    try {
        const dataParam                 =  {
                                                url,
                                                token,
                                                method:params.method,
                                                data:params.data
                                            }
        const data          = await fetchFn(dataParam);
        const submit        = await new Promise<{status:boolean, reason:string, result:object}>
                                ((resolve, reject) => {
                                    data.json()
                                    .then(e=>{
                                        resolve(e);
                                    }).catch((e)=>{
                                        reject(e);
                                    })  
                                });
                                
        status = submit?.status || false;
        reason = submit?.reason || "";
        result = submit?.result || {};
    } catch (error) {
        
        status  = false;
        reason  = "error fetch data";
        result  = {};
    }

    
    const response          = {status, reason, result};
    return response;
}   


    
async function fetchFn(params: { method?: string; url?: string; token?: string; data?: any; }): Promise<Response> {
    
    const timeout: number   = 5000;
    const controller        = new AbortController();
    const id                = setTimeout(() => controller.abort(), timeout);
    const endpoint          = params.url || "";
    const method            = (params?.method || 'GET').toUpperCase();
    const props:any         =   {
                                    method,
                                    headers: {
                                        "Content-type": "application/json",
                                        "Authorization": `Bearer ${params?.token}`,
                                    },
                                    signal: controller.signal 
                                }
    if (method === "POST") props.body = JSON.stringify(params?.data || {});

    const response      = await fetch(endpoint, props);

    clearTimeout(id);
    return response;
}